import { getAuthenticatedUser } from '../AuthHandler';
import { signOut } from 'aws-amplify/auth';

export type GQLResponse<T> = Promise<{
  data: T;
  errors?: [{ message: string }];
}>;

export const queryContentfulAPI = async <T>(
  query: string,
  variables?: Record<string, unknown>
): GQLResponse<T> => {
  // Ensures the user is authenticated
  await getAuthenticatedUser();

  // The long-lived Contentful cache accepts the GraphQL query and variables as
  // query params so a GET request can be used and therefore cached, whereas a
  // POST can't be cached by CloudFront
  const queryParams = new URLSearchParams({
    query,
    variables: JSON.stringify(variables),
  });
  const res = await fetch(`/contentful-api/?${queryParams.toString()}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (res.status === 401 || res.status === 403) {
    signOut();
  }

  return res.json();
};
